import * as transactionAccountsLib from '../api/transaction-accounts.js';
import { fetchLoadable } from '../fetchLoadable.js';
import * as actionTypes from './actionTypes.js';
export const getAll = () => fetchLoadable(actionTypes.FETCH_TRANSACTION_ACCOUNTS, transactionAccountsLib.getAll);
export const getImportById = (transactionImportId) => fetchLoadable(actionTypes.FETCH_TRANSACTION_IMPORT_BY_ID, transactionAccountsLib.getImportById, { transactionImportId });
//# sourceMappingURL=actions.js.map